import React from 'react';
import styles from './MobileForm.module.scss';
import Box from '@/components/UI/box/Box';
import Icon from '@/components/UI/icon/Icon';
import Typography from '@/components/UI/typography/Typography';
import TextField from '@/components/UI/textField/TextField';
const MobileForm = ({
  handleCleanClose,
  closeHandler,
  isPhrase,
  searchContent,
  searchTxt,
  handleClean,
  handleClickCity,
  allResult,
  handleSearch
}) => {
  const searchMainInput = React.useRef<HTMLInputElement>(null);
  return <Box className={styles['container']} data-sentry-element="Box" data-sentry-component="MobileForm" data-sentry-source-file="MobileForm.tsx">
      <Box className={styles['header']} onClick={() => {
      if (typeof handleCleanClose === 'function') {
        handleCleanClose();
      }
      isPhrase.current = true;
      searchContent.current?.classList.add('close-drawer');
      setTimeout(() => {
        closeHandler();
      }, 200);
    }} data-sentry-element="Box" data-sentry-source-file="MobileForm.tsx">
        <Icon name={'close'} type={'primary'} size={'xLarge'} data-sentry-element="Icon" data-sentry-source-file="MobileForm.tsx" />
        <Typography variant={'bodyL'} color={'neutral_800'} data-sentry-element="Typography" data-sentry-source-file="MobileForm.tsx">
          بستن صفحه
        </Typography>
      </Box>
      <form onClick={() => searchMainInput.current?.focus()} onSubmit={e => {
      e.preventDefault();
      if (searchTxt.startsWith('شم') || searchTxt.includes('شمال')) {
        handleClickCity('شمال', 'phrase');
      } else if (searchTxt?.trim()) {
        handleClickCity(!allResult?.length ? searchTxt : allResult?.[0]?.name, 'phrase');
      }
    }}>
        <TextField ref={ref => {
        ref?.focus();
        searchMainInput.current === ref;
      }} value={searchTxt} onChange={handleSearch} onClear={handleClean} icon={'search-normal'} label={'نام شهر یا کد آگهی'} data-sentry-element="TextField" data-sentry-source-file="MobileForm.tsx" />
        {/*<input*/}
        {/*  type="text"*/}
        {/*  placeholder="نام شهر یا کد آگهی"*/}
        {/*  value={searchTxt}*/}
        {/*  ref={searchMainInput}*/}
        {/*  onChange={handleSearch}*/}
        {/*  autoFocus*/}
        {/*/>*/}
        {/*{searchTxt && (*/}
        {/*  <IconButton onClick={handleClean} aria-label="clean" ref={clearInput}>*/}
        {/*    <CloseIcon htmlColor="#808080" />*/}
        {/*  </IconButton>*/}
        {/*)}*/}

        {/*{!searchTxt && <Icon type={'highEmphasis'} name={'search-normal-1'} />}*/}
      </form>
    </Box>;
};
export default MobileForm;